<template>
   <v-container>
      <v-row justify="center" align="stretch">
         <v-col cols="12" md="6" class="flex-column flex">
            <v-card flat>
               <v-img :src="require('@/assets/' + LOGIN_IMAGE)"></v-img>
            </v-card>
         </v-col>
         <v-col lg="6" md="6" sm="12" class="flex-column flex">
            <v-card class="pa-2" outlined tile elevation="2" color="">
               <v-form ref="loginform" v-model="isFormValid" @submit.prevent>
                  <div
                     class="
                        d-flex
                        flex-column
                        justify-space-between
                        align-center
                     "
                  >
                     <v-img
                        src="@/assets/hislogo.png"
                        :height="$vuetify.breakpoint.xs ? 50 : 100"
                        :width="$vuetify.breakpoint.xs ? 50 : 100"
                     ></v-img>
                  </div>
                  <h1 align="center">Sign In</h1>
                  <v-text-field
                     class="px-5"
                     v-model="email"
                     label="Email"
                     placeholder="Email address"
                     :rules="emailRules"
                     required
                  ></v-text-field>
                  <v-text-field
                     class="px-5"
                     v-model="password"
                     label="Password"
                     placeholder="Password"
                     type="password"
                     required
                  ></v-text-field>
                  <v-card-text class="red--text pt-2">{{ login_error_message }}</v-card-text>
                  <v-card-actions>
                     <v-btn color="primary" @click="StaffLogin">Staff Login</v-btn>
                     <v-spacer></v-spacer>
                     <v-btn
                        outlined
                        class="red darken-3 white--text px-6"
                        type="submit"
                        @click="doLogin"
                        >Login
                     </v-btn>
                  </v-card-actions>
               </v-form>
            </v-card>
         </v-col>
      </v-row>
   </v-container>
</template>

<script>
   import GlobalConstant from "@/common/globalconstant.js";

   export default {
      data() {
         return {
            ssotoken: "",
            usertoken: "",
            samltoken: "",
            isFormValid: true,
            email: "",
            emailRules: [
               (v) => !!v || "E-mail is required",
               (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
            ],
            password: "",
            login_error_message: "",
            SAML_BASEURL: GlobalConstant.SAML_URL,
            LOGIN_IMAGE: GlobalConstant.LOGIN_IMAGE,
         };
      },
      methods: {
         StaffLogin() {
            window.location.href = this.SAML_BASEURL + "/saml/login.php?sso";
         },

         doLogin: function() {
            if (this.$refs.loginform.validate()) {
               this.UserLogin();
            }
         },
         resetForm() {
            this.$refs.loginform.reset();
            this.$refs.loginform.resetValidation();
         },

         async UserLogin() {
            if (!this.$globalstore.user.isLoggedIn) {
               await this.$http({
                  url: "/common/userlogin.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     email: this.email,
                     userpass: this.password,
                     usertoken: "",
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.error) {
                     this.$globalstore.user.isLoggedIn = false;
                     this.$globalstore.user.tokenexpired = false;
                     this.$globalstore.user.userid = "";
                     this.$globalstore.user.useremail = "";
                     this.$globalstore.user.usertype = "";
                     this.$globalstore.user.username = "";
                     this.$globalstore.user.userroles = [];
                     this.$globalstore.user.usercap = [];
                     this.$globalstore.user.userMenu = [];
                     this.$globalstore.user.usertoken = "";
                     this.login_error_message = response.data.message;
                     this.resetForm();
                     return;
                  } else {
                     const userdata = response.data.userdata;
                     const token = userdata.usertoken;
                     localStorage.setItem("usertoken", token);

                     this.$globalstore.user.usertoken = token;
                     this.$globalstore.user.isLoggedIn = true;
                     this.$globalstore.user.tokenexpired = false;
                     this.$globalstore.user.userid = userdata.id;
                     this.$globalstore.user.useremail = userdata.email;
                     this.$globalstore.user.usertype = userdata.usertype;
                     this.$globalstore.user.username = userdata.username;
                     this.$globalstore.user.userlinkid = userdata.userlinkid;

                     // Save user roles
                     if (userdata.userroles) {
                        this.$globalstore.user.userroles = userdata.userroles;
                        const roles = userdata.userroles;
                        if (roles.length > 0) {
                           const role = roles[0];
                           this.$globalstore.user.rolename = role["role_description"];
                        }
                     }
                     // Save user caplist
                     if (userdata.usercap) {
                        this.$globalstore.user.usercap = userdata.usercap;
                     }
                     this.$globalstore.appready = true;
                     this.$globalstore.BuildMenu();

                     this.$router.push({name: "Home"}).catch(() => {});
                  }
               });
            }
         },
         async checkUserToken() {
            await this.$http({
               url: "/common/userToken.php",
               data: {usertoken: this.usertoken, source: "login"},
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               method: "POST",
            }).then((response) => {
               if (response.data.tokenexpired) {
                  this.$globalstore.user.isLoggedIn = false;
                  localStorage.removeItem("usertoken");
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.$globalstore.user.isLoggedIn = false;
                     localStorage.removeItem("usertoken");
                     this.login_error_message = response.data.message;
                  } else {
                     const userdata = response.data.userdata;

                     this.$globalstore.user.usertoken = this.usertoken;
                     this.$globalstore.user.isLoggedIn = true;
                     this.$globalstore.user.userid = userdata.id;
                     this.$globalstore.user.useremail = userdata.email;
                     this.$globalstore.user.usertype = userdata.usertype;
                     this.$globalstore.user.username = userdata.username;
                     this.$globalstore.user.userlinkid = userdata.userlinkid;

                     // Save user roles
                     if (userdata.userroles) {
                        this.$globalstore.user.userroles = userdata.userroles;
                        const roles = userdata.userroles;
                        if (roles.length > 0) {
                           const role = roles[0];
                           this.$globalstore.user.rolename = role["role_description"];
                        }
                     }
                     // Save user caplist
                     if (userdata.usercap) {
                        this.$globalstore.user.usercap = userdata.usercap;
                     }
                     this.$globalstore.appready = true;
                     this.$globalstore.BuildMenu();

                     this.$router.push({name: "Home"}).catch(() => {});
                  }
               }
            });
         },

         async checkSSOToken() {
            await this.$http({
               url: "/common/ssoToken.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {ssotoken: this.ssotoken},
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.login_error_message = "Invalid single-sign on request.";
                  return;
               } else {
                  let userdata = response.data.userdata;
                  localStorage.setItem("usertoken", userdata.usertoken);
                  this.$globalstore.user.isLoggedIn = true;
                  this.$globalstore.user.usertoken = userdata.usertoken;
                  this.$globalstore.user.userid = userdata.id;
                  this.$globalstore.user.useremail = userdata.email;
                  this.$globalstore.user.usertype = userdata.usertype;
                  this.$globalstore.user.username = userdata.username;
                  this.$globalstore.user.userlinkid = userdata.userlinkid;
                  this.$globalstore.user.usersso = this.ssotoken;

                  // Save user roles
                  if (userdata.userroles) {
                     this.$globalstore.user.userroles = userdata.userroles;
                     const roles = userdata.userroles;
                     if (roles.length > 0) {
                        const role = roles[0];
                        this.$globalstore.user.rolename = role["role_description"];
                     }
                  }
                  // Save user caplist
                  if (userdata.usercap) {
                     this.$globalstore.user.usercap = userdata.usercap;
                  }
                  this.$globalstore.user.userMenu = [];
                  this.$globalstore.appready = true;
                  this.$globalstore.BuildMenu();

                  this.$router.push({name: "Home"});
               }
            });
         },

         async checkSamlToken() {
            await this.$http({
               url: "/common/samlToken.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {samltoken: this.samltoken},
               method: "POST",
            }).then((response) => {
               if (response.data.error) {
                  this.login_error_message = response.data.message;
                  return;
               } else {
                  let userdata = response.data.userdata;
                  localStorage.setItem("usertoken", userdata.usertoken);
                  this.$globalstore.user.isLoggedIn = true;
                  this.$globalstore.user.usertoken = userdata.usertoken;
                  this.$globalstore.user.userid = userdata.id;
                  this.$globalstore.user.useremail = userdata.email;
                  this.$globalstore.user.usertype = userdata.usertype;
                  this.$globalstore.user.username = userdata.username;
                  this.$globalstore.user.userlinkid = userdata.userlinkid;
                  this.$globalstore.user.usersso = this.ssotoken;

                  // Save user roles
                  if (userdata.userroles) {
                     this.$globalstore.user.userroles = userdata.userroles;
                     const roles = userdata.userroles;
                     if (roles.length > 0) {
                        const role = roles[0];
                        this.$globalstore.user.rolename = role["role_description"];
                     }
                  }
                  // Save user caplist
                  if (userdata.usercap) {
                     this.$globalstore.user.usercap = userdata.usercap;
                  }
                  this.$globalstore.user.userMenu = [];
                  this.$globalstore.appready = true;
                  this.$globalstore.BuildMenu();

                  this.$router.push({name: "Home"});
               }
            });
         },
      },
      mounted() {
         this.ssotoken = this.$route.query.sso;
         this.usertoken = this.$route.query.usertoken;
         this.samltoken = this.$route.query.saml;

         if (this.ssotoken) {
            this.checkSSOToken();
         } else if (this.samltoken) {
            this.checkSamlToken();
         } else if (this.usertoken) {
            this.checkUserToken();
         }
         this.$globalstore.appready = true;
      },
   };
</script>
